import { Alert, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSubscriptionGate } from "../queries/useSubscriptionGate";

const BILLING_PATH = "/settings/billing";

/**
 * App-wide notice shown when the org's subscription needs attention. Hidden
 * while active/trialing and on the billing page itself. Phase 1 enforcement is
 * soft — it informs and links to billing rather than blocking access.
 */
export function BillingBanner() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoading, isActive, isPastDue, isBlocked } = useSubscriptionGate();

  if (isLoading || pathname === BILLING_PATH) return null;
  if (isActive && !isPastDue) return null;
  if (!isPastDue && !isBlocked) return null;

  const message = isPastDue
    ? "Your last payment failed. Update your payment method to keep access."
    : "Your organization doesn't have an active subscription.";

  return (
    <Alert
      severity={isPastDue ? "warning" : "error"}
      square
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => navigate(BILLING_PATH)}
        >
          {isPastDue ? "Fix payment" : "Subscribe"}
        </Button>
      }
    >
      {message}
    </Alert>
  );
}
